module.exports = __webpack_public_path__ + "static/gm-11-8bafc98c8a1c4b96a6289d3a70229537.jpg";